<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card>
          <v-card-title>
            <h4>{{ this.title }}</h4>
          </v-card-title>
          <v-container
            fluid
            v-if="selectBox"
            style="margin:0px; padding:0px 20px 0px 10px;"
          >
            <v-select
              :items="options"
              v-model="selected"
              label="Select"
              outlined
              @change="onChange()"
              style="margin:0px; padding:0px;"
            ></v-select>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-show="show_docs">
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card style="margin:0px; padding:0px;">
          <v-card-title style="margin:0px; padding:0px 10px 0px 20px;">
            Files
          </v-card-title>
          <v-container fluid style="margin:0px; padding:0px 10px 0px 20px;">
            <v-simple-table
              dense="dense"
              :fixed-header="fixedHeader"
              :height="height"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">File type</th>
                    <th class="text-left">Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in docs" :key="item">
                    <td>{{ item.substring(item.lastIndexOf("/") + 1) }}</td>
                    <td><span v-html="getFileType(item)"></span></td>
                    <td>
                      <v-btn
                        class="ma-1"
                        outlined
                        small
                        fab
                        color="indigo"
                        v-on:click="displayDoc(item)"
                        ><v-icon>mdi-download</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-show="show_imgs">
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card>
          <v-card-title style="margin:0px; padding:0px 10px 0px 20px;">
            Quicklooks
          </v-card-title>
          <v-container fluid style="margin:0px; padding:0px 10px 0px 20px;">
            <v-row>
              <v-col
                v-for="im in images"
                :key="im"
                class="d-flex child-flex"
                cols="3"
              >
                <v-card flat tile class="d-flex">
                  <v-img
                    :src="im"
                    :lazy-src="im"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    v-on:click="displayImg(im)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" offset-sm="0" v-show="show_map">
        <v-card>
          <v-card-title style="margin:0px; padding:0px 10px 0px 20px;">
            Map
          </v-card-title>
          <v-container fluid style="margin:0px; padding:0px 10px 0px 20px;">
            <div style="width: 100%; height: 300px" id="map"></div>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dense: false,
    fixedHeader: false,
    height: 300,
    docs: [],
    docsURL: [],
    images: [],
    kmls: [],
    selected: [],
    options: [],
    pathFile: "",
    map: null,
    show_docs: false,
    show_imgs: false,
    show_map: false,
    results: null
  }),
  props: {
    path: String,
    title: {
      type: String,
      default: "Documents"
    },
    selectBox: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange() {
      let tab = [];
      for (let p in this.results) {
        if (this.selected == p) tab = this.results[p];
      }

      this.displayResults(tab);
    },
    getFileType(f, titi) {
      console.log(titi);
      let ext = "";
      if (f.lastIndexOf(".") > 0)
        ext = f.substring(f.lastIndexOf(".") + 1).toUpperCase();

      return ext;
    },
    displayResults: function(tab) {
      this.docs = [];
      this.docsURL = [];
      this.images = [];
      this.kmls = [];
      this.show_docs = false;
      this.show_imgs = false;
      var tmpthis = this;
      this.map.invalidateSize();
      this.map.eachLayer(function(layer) {
        tmpthis.map.removeLayer(layer);
      });

      const osm = new L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox/satellite-streets-v11",
          accessToken:
            "pk.eyJ1IjoiZG91ZGFpZXYiLCJhIjoiY2syMzhlYnpzMDFpbjNucDltaTIzb2FneSJ9.DtU_NDpOdx1SJ04P8ueJcw"
        }
      );

      this.map.addLayer(osm);
      this.show_map = false;
      this.map.invalidateSize();

      for (let i = 0; i < tab.length; i++) {
        let ext = tab[i].substring(tab[i].lastIndexOf(".")).toUpperCase();
        if (ext == ".KML") {
          this.show_map = true;
          // Load kml file
          fetch("https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i])
            .then(res => res.text())
            .then(kmltext => {
              // Create new kml overlay
              const parser = new DOMParser();
              const kml = parser.parseFromString(kmltext, "text/xml");
              const track = new L.KML(kml);
              this.map.addLayer(track);
              this.map.invalidateSize();
              // Adjust map to show the kml
              const bounds = track.getBounds();
              this.map.fitBounds(bounds);
            });
        }

        if (ext == ".JSON") {
          this.show_map = true;
          axios
            .get("https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i])
            .then(response => {
              var geojsonMarkerOptions = {
                radius: 5000,
                weight: 1,
                opacity: 1,
                fillOpacity: 0.8,
                fillColor: "pink",
                color: "red"
              };
              this.map.invalidateSize();
              var datalayer = L.geoJson(response.data, {
                pointToLayer: function(feature, latlng) {
                  return L.circle(latlng, geojsonMarkerOptions);
                }
              });
              datalayer.addTo(this.map);
              const bounds = datalayer.getBounds();
              this.map.fitBounds(bounds);
            });
        }

        if (ext == ".PNG" || ext == ".GIF" || ext == ".JPG" || ext == ".JPEG") {
          this.images.push(
            "https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i]
          );
          this.show_imgs = true;
        } else {
          this.show_docs = true;
          this.docs.push(tab[i]);
        }
      }

      if (this.show_docs) {
        this.height = this.docs.length * 50 + 60;
        if (this.height > 300) this.height = 300;
      }
    },
    getResults: function() {
      this.show_docs = false;
      this.show_imgs = false;
      this.show_map = false;
      this.options = [];
      this.docs = [];
      this.docsURL = [];
      this.images = [];
      let wurl =
        "https://observations.ipsl.fr/aeris/eurec4aprod/list.php?p=" +
        this.pathFile;
      wurl = wurl + "&gen=true";

      axios.get(wurl).then(response => {
        this.results = response.data;
        let tab = [];
        if (this.selectBox) {
          for (let p in response.data) {
            if (Array.isArray(response.data[p])) {
              this.options.unshift(p);
              this.selected = p;
              tab = response.data[p];
            }
          }
        } else tab = response.data;

        this.displayResults(tab);
      });
    },
    displayImg: function(imag) {
      window.open(imag, "_blank");
    },
    displayDoc: function(d) {
      window.open(
        "https://observations.ipsl.fr/aeris/eurec4a-data/" + d,
        "_blank"
      );
    }
  },
  mounted: function() {
    this.pathFile = this.path;
    this.map = new L.Map("map", {
      center: new L.LatLng(13.164961, -59.43214),
      zoom: 4
    });
    this.getResults();
  },
  computed: {
    getContent() {
      return this.path;
    }
  },
  watch: {
    getContent(newContent, oldContent) {
      this.pathFile = newContent;
      this.getResults();
    }
  }
};
</script>
